import { PATH_DASHBOARD } from 'routes/paths';

export const courseResult = {
  items: [
    {
      title: 'courseResult.listAccredited.title',
      path: PATH_DASHBOARD.courseResult.listAccreditedProfession(),
      icon: 'fa6-solid:list-check'
    }
  ]
};
